export enum ClientId {
  Pabui = 'mobileui'
}
